import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { DeleteLayerRequest, DeleteLayerResponse, DuplicateLayerRequest, DuplicateLayerResponse, GetLayerRequest, GetLayerResponse, GetLayerSelectorRequest, GetLayerSelectorResponse, GetLayerUuidRequest, GetLayerUuidResponse, PatchLayerRequest, PatchLayerResponse, PostLayerRequest, PostLayerResponse } from './types/TLayerServices';

const URL_Prefix = '/layer';

export const layerService = createApi({
    reducerPath: 'layerService',
    baseQuery: getBaseQuery,
    tagTypes: ['Layer'],
    endpoints: (builder) => ({
        getLayer: builder.query<GetLayerResponse, GetLayerRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/`,
                method: 'GET',
                params: params,
            }),
        }),
        postLayer: builder.mutation<PostLayerResponse, PostLayerRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['Layer'],
        }),
        patchLayer: builder.mutation<PatchLayerResponse, PatchLayerRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: ['Layer'],
        }),
        getLayerUuid: builder.query<GetLayerUuidResponse, GetLayerUuidRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/${params.uuid}/`,
                method: 'GET',
                params: params,
            }),
        }),
        duplicateLayer: builder.mutation<DuplicateLayerResponse, DuplicateLayerRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/duplicate/`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['Layer'],
        }),
        getLayerSelector: builder.query<GetLayerSelectorResponse, GetLayerSelectorRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/selector/`,
                method: 'GET',
                params: params,
            }),
        }),
        deleteLayer: builder.mutation<DeleteLayerResponse, DeleteLayerRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/cascade/`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Layer'],
        }),
    }),
});

// Экспортируем все хуки, включая useLazySendCodeQuery
export const {
    useGetLayerQuery,
    useLazyGetLayerQuery,
    usePostLayerMutation,
    useGetLayerUuidQuery,
    useLazyGetLayerUuidQuery,
    usePatchLayerMutation,
    useDuplicateLayerMutation,
    useGetLayerSelectorQuery,
    useLazyGetLayerSelectorQuery,
    useDeleteLayerMutation
} = layerService;